import arrow from '../../../assets/images/icons/arrow-minimalistic.svg'
import { Button } from '..'
import { cardButtonStyle } from './index.css'

export const CardButton = (props: {
  children: React.ReactNode
  analytic?: {
    name: string
    params?: Record<string, string | number | boolean | undefined>
  }
  onClick: () => void
}) => (
  <Button
    className={cardButtonStyle}
    analytic={props.analytic}
    onClick={props.onClick}
  >
    <span>{props.children}</span>
    <img src={arrow} />
  </Button>
)
